@if (visible && operation) {
  <div class="historique-planifiee">
    <div class="historique-planifiee__overlay" (click)="fermer.emit()"></div>
    <section class="historique-planifiee__panel" role="dialog" aria-modal="true"
      aria-labelledby="historique-planifiee-titre" (keydown)="gererClavier($event)">
      <header class="historique-planifiee__header">
        <div>
          <h3 id="historique-planifiee-titre">Historique des opérations liées</h3>
          <p>{{ operation.libelle }}</p>
        </div>
        <button #fermerBouton type="button" class="historique-planifiee__close"
          aria-label="Fermer l’historique" (click)="fermer.emit()">&times;</button>
      </header>
      <div class="historique-planifiee__filtres" role="group" aria-label="Période de l’historique">
        <button type="button" [attr.aria-pressed]="periode === '12_MOIS'"
          (click)="periode = '12_MOIS'">12 derniers mois</button>
        <button type="button" [attr.aria-pressed]="periode === 'TOUT'"
          (click)="periode = 'TOUT'">Tout l’historique</button>
      </div>
      <div class="historique-planifiee__filtres" role="group" aria-label="Affichage de l’historique">
        <button type="button" [attr.aria-pressed]="affichage === 'MENSUEL'"
          (click)="affichage = 'MENSUEL'">Sommes mensuelles</button>
        <button type="button" [attr.aria-pressed]="affichage === 'DETAIL'"
          (click)="affichage = 'DETAIL'">Afficher les opérations détaillées</button>
      </div>
      <div class="historique-planifiee__body" aria-live="polite">
        @if (operations.length) {
          <p class="historique-planifiee__resume">
            {{ operations.length }} opération(s) · Total net : {{ total | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
          </p>
          <dl class="historique-planifiee__moyennes">
            <div>
              <dt>Moyenne mensuelle</dt>
              <dd [class.historique-planifiee__montant--sortie]="moyenneMensuelle !== null && moyenneMensuelle! < 0">
                @if (moyenneMensuelle !== null) {
                  {{ moyenneMensuelle | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
                } @else { — }
              </dd>
              @if (moyenneMensuelle !== null) {
                <small>{{ moisPourMoyenne.length }} mois avec des opérations, hors mois en cours</small>
              } @else {
                <small>Aucun mois précédent avec opération</small>
              }
            </div>
            <div>
              <dt>Montant moyen par opération</dt>
              <dd [class.historique-planifiee__montant--sortie]="moyenneOperation !== null && moyenneOperation! < 0">
                {{ moyenneOperation | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
              </dd>
              <small>Sur toutes les opérations de la période sélectionnée</small>
            </div>
          </dl>
          <div class="historique-planifiee__table">
            @if (affichage === 'MENSUEL') {
              <table>
                <caption class="historique-planifiee__caption">Sommes nettes par mois, du plus récent au plus ancien</caption>
                <thead><tr>
                  <th scope="col">Mois</th><th scope="col">Nombre d’opérations</th><th scope="col">Somme nette</th>
                </tr></thead>
                <tbody>
                  @for (mois of sommesMensuelles; track mois.mois) {
                    <tr>
                      <td>{{ mois.mois + '-01' | date:'MMMM yyyy':undefined:'fr-FR' }}</td>
                      <td>{{ mois.nombreOperations }}</td>
                      <td class="historique-planifiee__montant"
                        [class.historique-planifiee__montant--sortie]="mois.montant < 0">
                        {{ mois.montant | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
            <table>
              <caption class="historique-planifiee__caption">Opérations passées, de la plus récente à la plus ancienne</caption>
              <thead><tr>
                <th scope="col">Date</th><th scope="col">Libellé</th><th scope="col">Paiement</th>
                <th scope="col">Montant</th><th scope="col">Statut</th>
              </tr></thead>
              <tbody>
                @for (op of operations; track op.id) {
                  <tr>
                    <td>{{ op.dateOperation | date:'dd/MM/yyyy' }}</td>
                    <td>{{ op.libelle }}</td>
                    <td>{{ moyenPaiement(op) }}
                      @if (op.numeroCheque) { <small>N° {{ op.numeroCheque }}</small> }
                    </td>
                    <td class="historique-planifiee__montant"
                      [class.historique-planifiee__montant--sortie]="montantSigne(op) < 0">
                      {{ montantSigne(op) | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
                    </td>
                    <td>{{ op.estPointee ? 'Pointée' : 'Non pointée' }}</td>
                  </tr>
                }
              </tbody>
            </table>
            }
          </div>
        } @else {
          <p class="historique-planifiee__vide">Aucune opération passée liée pour cette période.</p>
        }
      </div>
      <footer class="historique-planifiee__footer">
        <button type="button" (click)="fermer.emit()">Revenir à l’édition</button>
      </footer>
    </section>
  </div>
}
